// extracted by mini-css-extract-plugin
export default {"play":"AudioPlayer_play__uO+IR","pause":"AudioPlayer_pause__WaYa8","audio":"AudioPlayer_audio__uuEg5"};